import { useState, useEffect } from "react";
import Nav from "./Nav";

const Header = () => {
  const [position, setPosition] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const moving = window.pageYOffset;
      setVisible(position > moving);
      setPosition(moving);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [position]);

  return (
    <header
      className={
        (visible ? "show top-0 " : "-top-full ") +
        "w-full flex justify-between items-center md:px-10 px-7 py-3 fixed left-0 top-0 transition-all duration-500 bg-[#0d0d0d] bg-opacity-70 backdrop-blur md:py-7"
      }
    >
      <h1 className="logo">
        <a href="/" className="block ransition-all">
          <img
            src="/logo_sj_c.png"
            alt="logo"
            className="md:w-8 md:h-8 w-7 h-7"
          />
        </a>
      </h1>
      <Nav />
    </header>
  );
};

export default Header;
